<template>
    <v-card class="pa-3">
        <v-row class="mx-0 mt-0 mb-4">
            <v-col cols="6" class="pb-0">
                <v-card-title class="ma-0 pa-0">
                    Nuevo Alimento
                </v-card-title>
            </v-col>
            <v-col cols="6" class="pb-0">
                <v-autocomplete dense outlined v-model="food.food_group" label="Grupo Alimenticio" :items="food_groups"></v-autocomplete>
            </v-col>
            </v-row>
        <v-row class="mx-0 mt-0">
            <v-col cols="6" class="pb-0">
                <v-text-field label="Alimento" v-model="food.name" outlined></v-text-field>
            </v-col>
            <v-col cols="6" class="pb-0">
                <v-text-field label="Peso Neto" suffix="g" v-model="food.net_weight" outlined></v-text-field>
            </v-col>
        </v-row>
        <div style="background:#f3f3f3; border-radius:4px;" class="my-4 py-4">
            <v-row class="mx-0">
                <v-col cols="6" class="pb-0">
                    <v-text-field label="Cantidad Sugerida" :suffix="food.unit_of_measurement" v-model="food.serving" outlined></v-text-field>
                </v-col>
                <v-col cols="6" class="pb-0">
                    <v-text-field label="Unidad de Medida" v-model="food.unit_of_measurement" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mx-0" v-for="(other_measurement, index) in food.other_measurements" :key="index">
                <v-col cols="1" class="pb-0">
                    <v-btn @click="food.other_measurements.splice(index, 1)" x-small class="mt-3 ml-3 elevation-0" color="black" dark fab><v-icon>mdi-minus</v-icon></v-btn>
                </v-col>
                <v-col cols="5" class="pb-0">
                    <v-text-field label="Cantidad Sugerida" :suffix="other_measurement.unit_of_measurement" v-model="other_measurement.serving" outlined></v-text-field>
                </v-col>
                <v-col cols="6" class="pb-0">
                    <v-text-field label="Unidad de Medida" v-model="other_measurement.unit_of_measurement" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mx-0 py-2">
                <v-spacer/>
                <v-btn class="elevation-0" @click="food.other_measurements.push({serving:'', unit_of_measurement:''})" x-small color="black" dark fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-spacer/>
            </v-row>
        </div>
        <v-row class="mx-0 mb-0">
            <v-col cols="4" class="pb-0">
                <v-text-field label="Carbohidratos" v-model="food.carbohydrates" outlined></v-text-field>
                <v-text-field label="Energia" v-model="food.energy" outlined></v-text-field>
                <v-text-field label="Acido Folico" v-model="food.folic_acid" outlined></v-text-field>
                <v-text-field label="Índice Glucémico" v-model="food.glycemic_index" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
                <v-text-field label="Proteina" v-model="food.protein" outlined></v-text-field>
                <v-text-field label="Fibra" v-model="food.fiber" outlined></v-text-field>
                <v-text-field label="Vitamina A" v-model="food.vitamin_a" outlined></v-text-field>
                <v-text-field label="Carga Glicemica" v-model="food.glycemic_load" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
                <v-text-field label="Lipidos" v-model="food.lipids" outlined></v-text-field>
                <v-text-field label="Potasio" v-model="food.potassium" outlined></v-text-field>
                <v-text-field label="Hierro" v-model="food.iron_no_hem" outlined></v-text-field>
                <v-text-field label="Ácido Ascórbico" v-model="food.ascorbic_acid" outlined></v-text-field>
            </v-col>
        </v-row>
        <v-card-actions>
            <v-spacer/>
            <v-btn rounded class="elevation-0 ml-2 px-4" color="grey" @click="close()" style="color:white!important;">Cancelar</v-btn>
            <v-btn rounded class="elevation-0 ml-2 px-4" color="black" @click="save()" :disabled="valid" :loading="gris" style="color:white!important;">Guardar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from "axios"
export default {
    data: () => ({
        gris:false,
        food:{
            name:'',
            unit_of_measurement:'',
            serving:'',
            net_weight:'',
            carbohydrates:'',
            outlined:'',
            folic_acid:'',
            glycemic_index:'',
            protein:'',
            fiber:'',
            vitamin_a:'',
            glycemic_load:'',
            lipids:'',
            potassium:'',
            iron_no_hem:'',
            ascorbic_acid:'',
            food_group:'',
            energy:'',
            other_measurements:[]
            /*approx_number_of_pieces_per_equivalent:'',
            rounded_gross_weight:'',*/
        },
        food_groups:[
            'Verdura',
            'Frutas',
            'Cereales sin grasa',
            'Cereales con grasa',
            'Leguminosas',
            'A.O.A Muy bajos en grasa',
            'A.O.A Bajo en grasa',
            'A.O.A Moderados en grasa',
            'A.O.A Alto en grasa',
            'Leche descremada',
            'Leche semidescremada',
            'Leche entera',
            'Leche con azúcar',
            'Aceites y grasas',
            'Aceites y grasas con proteínas',
            'Azucares sin grasa',
            'Azucares con grasa',
            'Alimentos libres en energía',
            'Bebidas alcoholicas'
        ]
    }),		
    computed:{
        valid(){
            if(
                (this.food.name!=''&&this.food.name!=undefined&&this.food.name!=null)
            ){
                return false
            }else{
                return true
            }
        }
    },
    methods:{
        close(){
            this.gris = false
            this.$nextTick(() => {
                this.$emit("closeCreateDialog", false);
            })
        },
        save(){
            this.gris = true
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/food",Object.assign(this.food)).then(response=>{
                this.close()
            })
        }
    }
}
</script>

<style>
.v-text-field__details{
    display: none!important;
}
</style>